<template>
  <div class="top-bar">
    <!-- Title Area -->
    <div class="title-area">
      <div class="contents">
        <i class="material-icons back-icon" @click="$router.push('/consoles')"
          >keyboard_arrow_left</i
        >
        <div class="flex-col mar-left-10">
          <h1 class="title">Locale.ai</h1>
          <p class="description">Data Studio</p>
        </div>
      </div>
    </div>

    <!-- Content area -->
    <div class="search-area" @click="$emit('clickSearch')">
      <icon size="20">map</icon>
      <p class="city-text flex-expand">{{ getCityName }}</p>
      <i class="material-icons search-icon">search</i>
    </div>
    <div class="icons-area">
      <div
        :class="['selection-icon', { active: !showMeasureTool }]"
        @click="toggleMeasureTool"
      >
        <i class="material-icons">touch_app</i>
        <div class="tooltip popup-shadow">
          <h4 class="tooltip-header">Selection mode</h4>
          <p class="tooltip-description">
            Helps you select items and move around the map
          </p>
        </div>
      </div>
      <div
        :class="['selection-icon', { active: showMeasureTool }]"
        @click="toggleMeasureTool"
      >
        <i class="material-icons">square_foot</i>
        <div class="tooltip popup-shadow">
          <h4 class="tooltip-header">Measure Distance mode</h4>
          <p class="tooltip-description">
            Helps you measure distance between points
          </p>
        </div>
      </div>
      <!-- <div
        :class="['selection-icon', { active: showMeasureTool }]"
        @click="toggleMeasureTool"
      >
        <i class="material-icons">comment</i>
        <div class="tooltip popup-shadow">
          <h4 class="tooltip-header">Comment mode</h4>
          <p class="tooltip-description">
            Add comments to anywhere in your map
          </p>
        </div>
      </div> -->
    </div>
    <div class="icons-area">
      <div class="dropdown-icon">
        <div class="icon-holder" @click="toggleOptions">
          <i class="material-icons main-icon">bubble_chart</i>
          <i class="material-icons caret md-18">keyboard_arrow_down</i>
        </div>
        <div v-if="!showOptions" class="tooltip popup-shadow">
          <h4 class="tooltip-header">Visualization options</h4>
          <p class="tooltip-description">
            Control the opacity and resolution of visualization
          </p>
        </div>
        <SlideYUpTransition>
          <div
            v-if="showOptions"
            v-click-outside="toggleOptions"
            class="drop-down-options popup-shadow"
          >
            <div class="option">
              <div class="header">
                <h4>Hexagon Size</h4>
              </div>
              <DropDown
                v-model="gridLevel"
                :options="options"
                placeholder="Choose resolution"
              />
            </div>
            <div class="option">
              <div class="header">
                <h4>Transperancy</h4>
                <span>{{ Math.round(getOpacity * 100) }}%</span>
              </div>
              <VueSlider v-model="opacity" @drag-end="setTransparency" />
            </div>
          </div>
        </SlideYUpTransition>
      </div>
    </div>
    <expand />
    <Button
      v-if="getConfig.isTempWidgets && !$route.query.dashboard_id"
      type="primary"
      text="save"
      :style="{ marginRight: '10px' }"
      @click="$emit('clickSave', { showSaveAsNewButton: false })"
    />
    <ButtonWithDropdown
      v-else-if="getConfig.isTempWidgets && $route.query.dashboard_id"
      type="primary"
      text="save"
      :style="{ marginRight: '10px' }"
      @click="emitSaveOrSaveAsNew"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Button from "@/components/global/views/Button";
import ButtonWithDropdown from "@/components/global/views/ButtonWithDropdown";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    Button,
    ButtonWithDropdown,
    SlideYUpTransition,
  },
  data() {
    return {
      showOptions: false,
      opacity: 100,
      options: [
        {
          name: "Cities",
          id: 0,
        },
        {
          name: "Districts",
          id: 1,
        },
        {
          name: "Neighbourhood",
          id: 2,
        },
        {
          name: "Buildings",
          id: 3,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("StudioManager", ["getConfig"]),
    ...mapGetters("Dashboards", ["getConsoles"]),
    ...mapGetters("StudioManager", ["getActiveGridLevel"]),
    ...mapGetters("Map", ["showMeasureTool", "getOpacity"]),
    ...mapGetters("Location", ["getActiveCity"]),
    gridLevel: {
      get() {
        return this.options[this.getActiveGridLevel];
      },
      set(value) {
        return this.setActiveGridLevel(value.id);
      },
    },
    getCityName() {
      if (this.getActiveCity && this.getActiveCity.name) {
        return this.getActiveCity.name;
      } else {
        return "All India";
      }
    },
  },
  methods: {
    ...mapActions("Map", ["toggleMeasureTool", "setOpacity"]),
    ...mapActions("StudioManager", ["setActiveGridLevel"]),
    setTransparency() {
      this.setOpacity({ opacity: this.opacity / 100 });
    },
    emitSaveOrSaveAsNew({ showSaveAsNewButton }) {
      if (showSaveAsNewButton) {
        this.$emit("clickSave", { showSaveAsNewButton });
      } else {
        // See if dashboard data is present in the store:
        if (this.getConsoles) {
          // Get the current console:
          let currentConsole = this.getConsoles.find(
            (consoles) => consoles.id == this.$route.query.dashboard_id
          );
          // If console data is present for currently opened console pass the data for prefilling of modal form:
          this.$emit("clickSave", {
            dashboardData: {
              name: currentConsole.name,
              description: currentConsole.description,
            },
            showSaveAsNewButton,
          });
        } else {
          // If console data is not present, simply don't pass the data and the form will be empty.
          this.$emit("clickSave", { showSaveAsNewButton });
        }
      }
    },
    toggleOptions() {
      this.showOptions = !this.showOptions;
    },
  },
  mounted() {
    this.opacity = this.getOpacity * 100;
  },
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: 100%;
  background: var(--color-secondary);
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 999;
  border-bottom: 1px solid var(--border-color);

  .title-area {
    width: 349px;
    max-width: 349px;
    height: 100%;
    border-right: 1px solid var(--border-color);

    .contents {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 10px;
      height: 100%;

      .back-icon {
        padding: 5px;
        background: var(--color-secondary-light);
        border-radius: 5px;
        margin: 0 5px;
        transition: 0.3s all ease-in-out;

        &:hover {
          cursor: pointer;
          color: var(--color-primary);
          background: var(--color-primary-light);
        }

        &:active {
          transform: scale(0.95);
        }
      }

      .title {
        font-size: 1rem;
      }

      .description {
        margin: 0;
        font-size: 0.8rem;
        opacity: 0.7;
      }
    }
  }

  .search-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 0px 8px 10px;
    margin: 0 5px;
    background: var(--color-secondary-light);
    border-radius: 5px;
    width: 300px;
    transition: 0.3s all ease-in-out;

    .city-text {
      margin: 0;
      padding: 0 10px;
    }

    .search-icon {
      color: var(--color-primary);
      margin: 0 10px;
    }

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }

    &:active {
      transform: scale(0.97);
    }
  }

  .icons-area {
    border-left: 1px solid var(--border-color);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;

    .selection-icon {
      margin-left: 7px;
      position: relative;

      &:first-child {
        margin-left: 0;
      }

      i {
        padding: 7px;
        border-radius: 3px;
        transition: 0.3s all ease-in-out;
        opacity: 0.7;

        &:hover {
          opacity: 1;
          cursor: pointer;
          color: var(--color-primary);
          background: var(--border-color);
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .tooltip {
        position: absolute;
        top: 50px;
        left: 0;
        white-space: nowrap;
        padding: 10px;
        background: var(--color-secondary);
        color: var(--font-color);
        border-radius: 5px;
        display: none;
        flex-direction: column;

        .tooltip-description {
          margin: 0;
          opacity: 0.7;
        }
      }

      &:hover {
        .tooltip {
          display: flex;
        }
      }

      &.active {
        i {
          opacity: 1;
          color: var(--color-primary);
          background: var(--color-primary-light);
        }
      }
    }

    .dropdown-icon {
      margin-left: 7px;
      position: relative;

      &:first-child {
        margin-left: 0;
      }

      .icon-holder {
        padding: 5px;
        border-radius: 3px;
        transition: 0.3s all ease-in-out;

        &:hover {
          cursor: pointer;
          color: var(--color-primary);
          background: var(--border-color);

          + .tooltip {
            display: flex;
          }
        }

        &:active {
          transform: scale(0.9);
        }
      }

      .tooltip {
        position: absolute;
        top: 50px;
        left: 0;
        white-space: nowrap;
        padding: 10px;
        background: var(--color-secondary);
        color: var(--font-color);
        border-radius: 5px;
        display: none;
        flex-direction: column;

        .tooltip-description {
          margin: 0;
          opacity: 0.7;
        }
      }

      .drop-down-options {
        position: absolute;
        top: 50px;
        border-radius: 5px;
        background: var(--color-secondary);
        width: 250px;

        .option {
          padding: 15px;
          border-bottom: 1px solid var(--border-color);

          .header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }

      // &:hover {
      //   .tooltip {
      //     display: flex;
      //   }
      // }
    }
  }
}
</style>
